<!--
Author: XiangChenYu
Date: 2019-10-24
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div :class="'view-assets-info b-most bg-white view ' + className">
        <comp-title :title="title" />
        <div class="assets-tit border-bot">
            我的资产
            <!-- <span class="trade-msg">
                您有<strong>1</strong>笔交易正在确认中
                <el-button type="text" v-on:click="$router.push({name:'traderecord'})">[查看交易记录]</el-button>
            </span> -->
        </div>
        <el-row class="cur-info-box">
            <el-col :span="18" class="assets-con">
                <el-col :span="9" class="cur-all">
                    <span class="icon-img" />
                    <div class="icon-info">
                        <span class="amount all">{{ $util.fmtNum(Number(allAssets.commonasset)+Number(allAssets.specialasset)) }}</span>
                        <span class="amount-info">基金总额(元)</span>
                    </div>
                </el-col>
                <el-col :span="7">
                    <span class="icon-img yes" />
                    <div class="icon-info">
                        <span class="amount" :class="Number(allAssets.specialyesincome)+Number(allAssets.generalyestincome)>0?'add':(Number(allAssets.specialyesincome)+Number(allAssets.generalyestincome)<0?'reduce':'')">{{ $util.fmtNum(Number(allAssets.specialyesincome)+Number(allAssets.generalyestincome)) }}</span>
                        <span class="amount-info">昨日收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span class="icon-img all" />
                    <div class="icon-info">
                        <span
                            class="amount"
                            :class="Number(allAssets.generalIncome)+Number(allAssets.specialIncome)>0?'add':(Number(allAssets.generalIncome)+Number(allAssets.specialIncome)<0?'reduce':'')"
                        >{{ $util.fmtNum(Number(allAssets.generalIncome)+Number(allAssets.specialIncome)) }}</span>
                        <span class="amount-info">累计收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="cur-btn-group other-btn1">
                        <!-- <el-button type="text" v-on:click.once="$router.push({name:'fund'})">
                            <i class="xjb-icon detail" />收益明细
                        </el-button> -->
                        <el-button type="text" v-on:click.once="$router.push({name:'traderecord'})">
                            <i
                                class="xjb-icon records"
                            />交易记录
                        </el-button>
                        <!-- <el-button type="text" v-on:click.once="$router.push({name:'traderecord'})">
                            <i
                                class="xjb-icon withdraw"
                            />交易撤单
                        </el-button> -->
                    </div>
                </el-col>
            </el-col>
            <!-- v-if="false"控制：暂时禁用交易功能，汇款支付上线再放开 -->
            <el-col v-if="$util.getConfig().hideFunc" :span="6" class="others">
                <div class="cur-btn-group btn-xjb">
                    <div>
                        <el-button type="yellow" v-on:click.once="$router.push({name:'fund'})">
                            <i class="xjb-icon charge" />我要买基金<i
                                class="el-icon-arrow-right el-icon--right"
                            />
                        </el-button>
                    </div>
                    <!--<div>-->
                    <!--<el-button type="red" v-on:click.once="$router.push({name:'cfund'})">-->
                    <!--<i class="xjb-icon redemption" />基金赎回<i-->
                    <!--class="el-icon-arrow-right el-icon&#45;&#45;right"-->
                    <!--/>-->
                    <!--</el-button>-->
                    <!--</div>-->
                    <div>
                        <el-button type="blue" v-on:click.once="$router.push({name:'cfund'})">
                            <i class="xjb-icon transform" />基金转换<i
                                class="el-icon-arrow-right el-icon--right"
                            />
                        </el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "AssetsInfo",
    components: {
    },
    mixins: [mixin],
    data () {
        return {
            dataSet: { // options选项配置
                cutoutPercentage: 80, // 甜甜圈图形内径占有整个图形的比例
                tooltips: {
                    enabled: false // 不显示提示
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                }
            },
            allAssets: {},
            userType: ""

        };
    },
    created () {
        const info = this.$cache.getUser();
        this.getAll();
        if (info) {
            this.userType = info.usertype;
        }
    },
    methods: {
        toPage (val) {
            if (this.userType !== "3" && this.userType !== "4") {
                val = "currencyfund";
            }
            this.$router.push({ name: val });
        },
        getAll () {
            const _this = this;
            this.$util.request("acct/asset/total").then(res => {
                if (res.data) {
                    _this.allAssets = res.data[0][0];
                }
            });
        }
        // // 获取现金宝信息
        // getXjbInfo () {
        //     this.$util.request("xjb/query/asset").then(res => {
        //         if (res.data) {
        //             this.xjbInfo = res.data[0];
        //         }
        //     });
        // }
    }
};
</script>
<style lang="scss">
.view-assets-info {
    .cur-info-box .el-col .other-btn1 {
        padding-left: 20px;
        text-align: left;
        .el-button + .el-button {
            margin-left: 60px;
        }
        .el-button {
            font-size: 14px;
            i {
                &.detail {
                    background: url("../../assets/img/icon.png") -370px -226px no-repeat;
                }
                &.my-plan {
                    background: url("../../assets/img/icon.png") -369px -260px no-repeat;
                }
            }
        }
    }
}
</style>
